import { useFeatureFlagEnabled } from '@posthog/react';

export const REPORT_PROBLEM_FLAG = 'report-a-problem-enabled';

/** Pure predicate, extracted so it can be unit-tested under bun:test without mocking PostHog. */
export const isReportProblemEnabled = (flag: boolean | undefined): boolean => flag === true;

export function useReportProblemEnabled(): boolean {
  return isReportProblemEnabled(useFeatureFlagEnabled(REPORT_PROBLEM_FLAG));
}
